import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import Button from 'atoms/buttons/Button';
import { Horizontal } from 'atoms/layout/flex';
import { Layout } from 'components/cardswap/Layout';
import { CenterVertically } from 'components/cardswap/Layout/CenterVertically';
import { Header } from 'components/cardswap/Layout/Header';
import { StepProps } from 'components/cardswap/types';
import { useCardSwapContext } from 'components/cardswap/useCardSwapContext';
import { glossary } from 'lib/glossary';

const YourCard = styled(Horizontal).attrs({ gap: 0, center: true })``;

type Props = StepProps & {
  renderCard: ReactNode;
};

export const WelcomeToTheTeam = ({ onClose, renderCard }: Props) => {
  const { formatMessage } = useIntl();
  const { clearCardSwapState } = useCardSwapContext();

  return (
    <Layout
      main={
        <CenterVertically>
          <Header
            title={formatMessage({
              id: 'CardSwap.WelcomeToTheTeam.title2',
              defaultMessage: 'Welcome to the team',
            })}
            subtitle={formatMessage({
              id: 'CardSwap.WelcomeToTheTeam.subtitle',
              defaultMessage: 'Your Card will be available in a few minutes',
            })}
          />
          <YourCard>{renderCard}</YourCard>
        </CenterVertically>
      }
      footer={
        <Button
          color="tertiary"
          onClick={() => {
            clearCardSwapState();
            onClose!();
          }}
          size="large"
        >
          {formatMessage(glossary.close)}
        </Button>
      }
    />
  );
};
